import React from 'react';

export abstract class ComponentSetStatePromised<Props = Record<string, unknown>, State = Record<string, unknown>> extends React.Component<
    Props,
    State
> {
    constructor(props: Props) {
        super(props);
        this.state = {} as any;
    }

    public async setStatePromised<K extends keyof State>(
        state: ((prevState: Readonly<State>) => Pick<State, K> | State | null) | (Pick<State, K> | State | null),
    ): Promise<void> {
        return new Promise((resolve) => {
            super.setState(state, () => {
                resolve();
            });
        });
    }
}
